
import React from 'react';
import { Button } from '../components/ui/Button';

interface CookiesProps {
  onNavigate: (page: string) => void;
}

export const Cookies: React.FC<CookiesProps> = ({ onNavigate }) => {
  return (
    <div className="w-full pt-32 pb-16 px-4 bg-white min-h-screen">
      <div className="max-w-4xl mx-auto prose prose-stone animate-in fade-in duration-500">
        <h1 className="font-serif text-4xl font-bold text-mabelita-dark mb-8 border-b pb-4">Política de Cookies</h1>
        
        <div className="bg-blue-50 p-6 rounded-xl border border-blue-100 mb-8">
            <p className="text-blue-800 m-0">
                <strong>Última actualización:</strong> {new Date().toLocaleDateString()}
            </p>
        </div>

        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          En <strong>Mabelita de la Cruz</strong>, valoramos tu privacidad y queremos ser transparentes sobre cómo utilizamos la tecnología para mejorar tu experiencia. Esta política detalla el uso de cookies en nuestra plataforma.
        </p>

        <h3 className="font-serif text-2xl font-bold mt-12 mb-4 text-mabelita-dark">1. ¿Qué son las cookies?</h3>
        <p className="text-gray-600">
          Las cookies son pequeños archivos de texto que los sitios web guardan en tu ordenador o dispositivo móvil cuando los visitas. Permiten que el sitio web recuerde tus acciones y preferencias (como el inicio de sesión, el idioma, el tamaño de la fuente y lo que tienes en el carrito de compras) durante un período de tiempo.
        </p>

        <h3 className="font-serif text-2xl font-bold mt-12 mb-4 text-mabelita-dark">2. Tipos de cookies que utilizamos</h3>
        <div className="grid md:grid-cols-2 gap-6 my-8">
            <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="font-bold text-lg mb-2">🍪 Esenciales</h4>
                <p className="text-sm text-gray-600">Necesarias para el funcionamiento técnico. Permiten la navegación, acceso a áreas seguras y, crucialmente, <strong>mantener los productos en tu carrito de compras</strong> mientras navegas.</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="font-bold text-lg mb-2">📊 Analíticas</h4>
                <p className="text-sm text-gray-600">Nos ayudan a entender cómo los visitantes interactúan con la web, recopilando información de forma anónima para mejorar nuestro contenido y diseño.</p>
            </div>
        </div>

        <h3 className="font-serif text-2xl font-bold mt-12 mb-4 text-mabelita-dark">3. Gestión de tus preferencias</h3>
        <p className="text-gray-600 mb-6">
          Puedes controlar y/o eliminar las cookies según desees. Puedes borrar todas las cookies que ya están en tu ordenador y configurar la mayoría de los navegadores para evitar que se coloquen. Sin embargo, si haces esto, es posible que tengas que ajustar manualmente algunas preferencias cada vez que visites un sitio y que algunos servicios y funcionalidades (como el carrito de compras) no funcionen.
        </p>

        <div className="mt-16 pt-8 border-t border-gray-200 text-center">
          <p className="mb-6 font-medium text-gray-500">¿Estás listo para seguir explorando?</p>
          <div className="flex justify-center gap-4">
             <Button onClick={() => onNavigate('home')} variant="outline">
                Volver al Inicio
             </Button>
             <Button onClick={() => onNavigate('shop')} variant="primary">
                Ir a la Tienda
             </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
